import { Injectable } from '@angular/core';
import moment from 'moment/moment';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import {
  gqlMongoByKey,
  gqlMongoDoc,
  gqlMongoLoad,
} from '../../../shared/classes/loopback-custom-store/generic/store.utils';
import { hAll } from '../../../shared/classes/utils/utils';
import { DataSourceService } from '../../../shared/modules/my-common/services/datasource.service';
import { ActiveClientSignatureView, ActiveClientSignatureViewApi, Consumer, ConsumerApi } from '../../../shared/sdk';
import { INavinetAuthDoc, TAppMealClaimSet } from './auth-claim.type';

@Injectable()
export class EditClaimService {
  constructor(private dss: DataSourceService) {}

  // getActiveE9yDocs() {
  //   return oc(this.data)
  //     .member.e9y([])
  //     .filter(doc => oc(doc).status.active());
  // }

  getMoments(yyyymm: number) {
    const m = moment(yyyymm + '01', 'YYYYMMDD');
    return {
      yyyymm: Number(m.clone().format('YYYYMM')),
      som: m.clone().startOf('month'),
      eom: m.clone().endOf('month'),
      somw: m.clone().startOf('month').startOf('week'),
      eomw: m.clone().endOf('month').endOf('week'),
    };
  }

  getConsumer$(cId?: number) {
    return cId
      ? this.dss
          .getApi<ConsumerApi>(Consumer)
          .findById<Consumer>(cId, { include: [{ person: { contact: ['addresses', 'phones'] } }] }, hAll)
          .pipe(catchError(() => of<null>(null)))
      : of<null>(null);
  }

  getAuth$(authId: string) {
    return authId ? gqlMongoByKey<INavinetAuthDoc>(this.dss, 'ExportsAuthsDataCache', authId) : of<null>(null);
  }

  getMemberSigns$(mci: string, yyyymm: number) {
    return this.dss
      .getApi<ConsumerApi>(Consumer)
      .find<Consumer>(
        {
          where: { mci },
          fields: { id: true, mci: true },
          // limit: 1,
        },
        hAll,
      )
      .pipe(
        switchMap(clients =>
          clients.length
            ? this.dss.getApi<ActiveClientSignatureViewApi>(ActiveClientSignatureView).find<ActiveClientSignatureView>(
                {
                  where: {
                    and: [
                      { vServiceType: 'MEALS' },
                      { vdate: { gte: this.getMoments(yyyymm).somw.format('YYYY-MM-DD') } },
                      { vdate: { lte: this.getMoments(yyyymm).eomw.format('YYYY-MM-DD') } },
                      // { tenantId: this.selectedAuth._tenantId },
                      { consumerId: { inq: clients.map(c => c.id) } },
                    ],
                  },
                },
                hAll,
              )
            : of([] as ActiveClientSignatureView[]),
        ),
      );
  }

  getClaimSet$(authId: string, yyyymm: number) {
    return authId
      ? gqlMongoDoc<TAppMealClaimSet>(this.dss, 'MealClaims', { 'auth._id': authId, 'meta.yyyymm': yyyymm })
      : of<null>(null);
  }

  getNavinetClaims$(auth: INavinetAuthDoc) {
    const aggregate = [
      {
        $match: {
          _mci: oc(auth)._mci(),
          SVCStartDT: { $lte: { $date: { v: oc(auth).EndDT() } } },
          SVCEndDT: { $gte: { $date: { v: oc(auth).StartDT() } } },
        },
      },
      {
        $project: {
          _source: 0,
        },
      },
      {
        $sort: { ClaimID: 1 },
      },
    ];

    return auth ? gqlMongoLoad(this.dss, 'Navinet_KFCHC_ClaimStatusImports', {}, aggregate) : of<[]>([]);
  }

  // getE9yDoc$(claimSet: TAppMealClaimSet) {
  //   let e9yDocs: IStediE9yDoc[];
  //
  //   e9yDocs = [
  //     ...oc(claimSet)
  //       .e9ies([])
  //       .map(e => e.e9y),
  //     // ...oc(this.data).member.e9y([]),
  //   ];
  //
  //   if (e9yDocs.length > 0) {
  //     e9yDocs = e9yDocs.filter(doc => oc(doc).status.active());
  //
  //     const e9yDoc = oc(this.lastClaim).request()
  //       ? e9yDocs.find(d => d.e9y === oc(this.lastClaim).request.tradingPartnerServiceId())
  //       : e9yDocs.find(
  //           d =>
  //             oc(d).response.tradingPartnerServiceId('') === '6751' &&
  //             (oc(d).response.payer.name('').includes('ALIGNED') || oc(d).response.payer.name('').includes('VIP')),
  //         ) ||
  //         e9yDocs.find(
  //           d =>
  //             oc(d).response.tradingPartnerServiceId('') === '8121' &&
  //             !oc(d).response.payer.name('').includes('ALIGNED') &&
  //             !oc(d).response.payer.name('').includes('VIP'),
  //         ) ||
  //         e9yDocs[0];
  //
  //     const key = oc(e9yDoc)._id();
  //     return key ? gqlMongoByKey<IStediE9yDoc>(this.dss, 'StediEligibilityDataCache', key) : of<null>(null);
  //   } else {
  //     const [e9yId] = oc(this.data)
  //       .member.e9y([])
  //       .map(d => d._id);
  //
  //     return e9yId ? gqlMongoByKey<IStediE9yDoc>(this.dss, 'StediEligibilityDataCache', e9yId) : of<null>(null);
  //   }
  // };
}
